const API_BASE_URL = import.meta.env.VITE_API_URL;

// auth endpoints
export const login = `${API_BASE_URL}/api/login`;
export const register = `${API_BASE_URL}/api/register`;
export const initiateResetPassword = `${API_BASE_URL}/api/reset-password`;
export const confirmResetPassword = `${API_BASE_URL}/api/reset-password/confirm`;
export const fbAuth = `${API_BASE_URL}/api/auth/facebook`;
export const disconnectOrReconnectIG = `${API_BASE_URL}/api/customer/disconnect-instagram`;
export const igStatus = `${API_BASE_URL}/api/instagram/connection-status`;
export const createAblyClient = `${API_BASE_URL}/api/websocket/create-client`;

// trial endpoints
export const initiateTrial = `${API_BASE_URL}/api/trial/initiate`;
export const createSubscription = `${API_BASE_URL}/api/payment/create-subscription`;
export const updateTrialDetails = `${API_BASE_URL}/api/trial/update-details`;
export const getAvailableInstagramConnections = `${API_BASE_URL}/api/customer/available-instagram-connections`;
export const customerSelectInstagramConnection = `${API_BASE_URL}/api/customer/select-instagram-connection`;

// opens endpoints
export const opensLogin = `${API_BASE_URL}/api/customer/opens-login`;
export const opens2fa = `${API_BASE_URL}/api/customer/opens-2fa`;
export const opensStatus = `${API_BASE_URL}/api/customer/opens-status`;
export const allowedOpensConfig = `${API_BASE_URL}/api/customer/allowed-opens-config`;
export const opensConfig = `${API_BASE_URL}/api/customer/automated-opens`;
export const selfServiceOpensSettings = `${API_BASE_URL}/api/customer/self-service-opens-settings`;
export const regenerateSelfServiceOpensMessage = `${API_BASE_URL}/api/followers/regenerate-opens-message`;

// linkedin endpoints
export const linkedinConnect = `${API_BASE_URL}/api/linkedin/connect`;
export const linkedinReconnect = `${API_BASE_URL}/api/linkedin/reconnect`;
export const linkedinStatus = `${API_BASE_URL}/api/linkedin/connection-status`;
export const registerWebhookLinkedin = `${API_BASE_URL}/api/linkedin/webhook/register`;
export const getLinkedinAccountDetails = (accountId) =>
  `${API_BASE_URL}/api/linkedin/account/${accountId}`;
export const linkedinPosts = `${API_BASE_URL}/api/linkedin/posts`;

// instagram direct endpoints
export const instagramDirectConnect = `${API_BASE_URL}/api/auth/instagram`;

// email/sendgrid endpoints
export const saveEmailSettings = `${API_BASE_URL}/api/sendgrid/settings`;
export const sendEmail = `${API_BASE_URL}/api/email/send`;

// conversation/contact endpoints
export const conversationList = `${API_BASE_URL}/api/conversations`;
export const contactDetails = (contactId) =>
  `${API_BASE_URL}/api/contacts/${contactId}`;
export const contactMessages = (contactId) =>
  `${API_BASE_URL}/api/messages/${contactId}`;
export const sendMessage = `${API_BASE_URL}/api/instagram/send-message`;
export const sendMessageLinkedin = `${API_BASE_URL}/api/linkedin/send-message`;
export const sendMessageSMS = `${API_BASE_URL}/api/sms/send`;
export const sendMedia = (contactId) =>
  `${API_BASE_URL}/api/instagram/send-media?contact_id=${contactId}`;

// Endpoints related to tags
export const customerTagList = `${API_BASE_URL}/api/list-tags`;
export const newCustomerTagList = `${API_BASE_URL}/api/tag`;
export const addContactTag = `${API_BASE_URL}/api/contact/add-tag`;
export const contactTagList = (contactId) =>
  `${API_BASE_URL}/api/contact/list-tags?contact_id=${contactId}`;
export const removeContactTag = `${API_BASE_URL}/api/contact/remove-tag`;
export const createTag = `${API_BASE_URL}/api/tag`;
export const updateOrDeleteTag = (tagId) => `${API_BASE_URL}/api/tag/${tagId}`;

export const setContactStatus = `${API_BASE_URL}/api/contact/status`;
export const assignAgent = `${API_BASE_URL}/api/contact/assign-agent`;
export const addContactNote = `${API_BASE_URL}/api/contact/note`;
export const contactNote = (contactId) =>
  `${API_BASE_URL}/api/contact/note?contact_id=${contactId}`;
export const attachPlan = `${API_BASE_URL}/api/contact/attach-plan`;

// report endpoints
export const agentActivityReport = `${API_BASE_URL}/api/report/messages`;
export const offerPresentedReport = `${API_BASE_URL}/api/report/offer-presented`;
export const closedWonReport = `${API_BASE_URL}/api/report/closed-won`;

export const dashboardReport = `${API_BASE_URL}/api/report/funnel-chart`;
export const funnelTags = `${API_BASE_URL}/api/funnel-tags`;
export const responsivenessReport = `${API_BASE_URL}/api/report/responsiveness`;

// coach-view endpoints
export const coachViewMessages = `${API_BASE_URL}/api/admin/coach-view`;
export const coachContactViewMessages = `${API_BASE_URL}/api/admin/coach-contact-view`;

// system endpoints
export const userDetails = `${API_BASE_URL}/api/user/detail`;
export const agentCreate = `${API_BASE_URL}/api/agents/create`;
export const agentList = `${API_BASE_URL}/api/agents/list`;
export const planCreate = `${API_BASE_URL}/api/plan/create`;
export const planList = `${API_BASE_URL}/api/plan/list`;
export const planUpdate = `${API_BASE_URL}/api/plan/update`;
export const planDelete = (planId) =>
  `${API_BASE_URL}/api/plan/delete/${planId}`;

// crm endpoints - https://qa.sbccrm.com/bld/api/contact/search
export const crmContactSearch = (pageNumber) =>
  `${API_BASE_URL}/api/contact/search?page=${pageNumber}`;

// follower upload
const SCRAPPER_URL = 'https://scrapper.sbccrm.com';
export const followerUpload = (uploadId) =>
  `${SCRAPPER_URL}/upload?upload-id=${uploadId}`;
export const followerUploadHistory = (pageNumber) =>
  `${SCRAPPER_URL}/uploads?page=${pageNumber}&per_page=5`;

// comment urls
export const commentThread = (messageId) =>
  `${API_BASE_URL}/api/message/${messageId}`;
export const replyToComment = `${API_BASE_URL}/api/instagram/reply-to-comment`;

// reaction url
export const reactMessage = (channel) =>
  `${API_BASE_URL}/api/${channel}/message/react`;

// agent goals
export const goals = `${API_BASE_URL}/api/goals`;

// agent lead allocation
export const agentLeadAllocation = `${API_BASE_URL}/api/agents/lead-allocation`;

// agent manage
export const updateAgentRole = (agentId) =>
  `${API_BASE_URL}/api/agents/${agentId}/role`;
export const deleteAgent = (agentId) => `${API_BASE_URL}/api/agents/${agentId}`;
export const resetUserPasswordEndpoint = `${API_BASE_URL}/api/customer/admin/set-user-password`;
export const setAgentCalendarUrl = (agentId) =>
  `${API_BASE_URL}/api/agents/${agentId}/calendar-url`;

// canned-responses
export const cannedResponses = `${API_BASE_URL}/api/canned-responses`;
export const updateOrDeleteCannedMessage = (cannedResponseId) =>
  `${API_BASE_URL}/api/canned-responses/${cannedResponseId}`;

export const changePasswordEndpoint = `${API_BASE_URL}/api/change-password`;

export const manage2fa = `${API_BASE_URL}/api/2fa/manage`;
export const verify2fa = `${API_BASE_URL}/api/2fa/verify`;
export const switch2fa = `${API_BASE_URL}/api/2fa/send`;

// copilot endpoints
export const copilotChat = `${API_BASE_URL}/api/copilot/chat`;
export const copilotSettings = `${API_BASE_URL}/api/agents/copilot-servicesettings`;

// details submit endpoint
export const detailsSubmit = `${API_BASE_URL}/api/customer/credentials`;

// workflow endpoints
export const workflows = `${API_BASE_URL}/api/workflows`;
export const workflowInstances = `${API_BASE_URL}/api/workflows/instances`;
export const workflowInstance = (workflowInstanceId) =>
  `${API_BASE_URL}/api/workflows/${workflowInstanceId}`;
export const workflowMatchedContacts = `${API_BASE_URL}/api/workflows/matched-contacts`;

// Sales Bot endpoints
export const salesBotPredict = `${API_BASE_URL}/api/salesbot/demo-predict`;
export const manageSalesBotFeature = `${API_BASE_URL}/api/autopilot/manage`;
export const takeoverFromSalesBot = `${API_BASE_URL}/api/contact/takeover-from-autopilot`;
export const autopilotPrompt = `${API_BASE_URL}/api/autopilot/salesbot/system-prompt`;
export const autopilotSettings = `${API_BASE_URL}/api/customer/autopilot/settings`;

// transcription endpoints
export const transcribeAudio = (messageId) =>
  `${API_BASE_URL}/api/message/${messageId}/transcription`;

// follower endpoints
export const followersSearch = (pageNumber) =>
  `${API_BASE_URL}/api/followers/search?page=${pageNumber}`;
export const personalizeOpens = `${API_BASE_URL}/api/followers/personalize-opens`;
export const selfServiceStatus = `${API_BASE_URL}/api/followers/self-service-status`;
export const previewOpensMessage = `${API_BASE_URL}/api/followers/preview-opens-message`;
export const responseReport = `${API_BASE_URL}/api/opens/report`;

// notifications
export const notifications = `${API_BASE_URL}/api/notifications`;
export const notificationsRead = `${API_BASE_URL}/api/notifications/read`;

// Integrations endpoints
export const integrationsStatus = `${API_BASE_URL}/api/customer/integrations`;
export const integrationsSettings = `${API_BASE_URL}/api/customer/integrations/settings`;
// calendly endpoints
export const calendlyOAuthUrl = `${API_BASE_URL}/api/calendly/oauth-url`;
// ghl calendar endpoints
export const ghlOAuthUrl = `${API_BASE_URL}/api/ghlcalendar/oauth-url`;
// elevenlabs endpoints
export const elevenlabsGenerate = `${API_BASE_URL}/api/voice/elevenlabs/generate`;
